import { Component, OnInit } from '@angular/core';
import {WishlistService} from '../services/wishlist.service';
import {TourService} from '../services/tour.service';
import {TourApiService} from '../services/tour-api.service';
import {EnumAware} from '../decorators/enum-aware.decorator';
import {ModalService} from '../services/modal.service';
import {TrackingService} from '../services/tracking.service';
import {ImageSize} from '../model/image';
import {MicroApiService} from '../services/micro-api.service';
import {OptionDetailService} from '../services/option-detail.service';

@Component({
  selector: 'gt-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.css', './tour.component.css', './option-detail.component.css']
})
@EnumAware
export class WishlistComponent implements OnInit {

  constructor(public apiService: TourApiService,
              public tourService: TourService,
              public modalService: ModalService,
              public wishlistService: WishlistService,
              private trackingService: TrackingService,
              private microService: MicroApiService,
              public optionDetailService: OptionDetailService) {}

  ngOnInit() {
    this.tourService.setDocumentTitleWithTour(this.tourService.tourFeatureTitle('wishlist'));
    this.trackingService.trackAction(TrackingService.kActionWishList, null, 0);
    // if (!this.wishlistService.wishlistLoaded) {
    //   this.wishlistService.loadWishlist();
    // }
  }

  exportWishList() {

    this.microService.storePublicDataAsString(JSON.stringify(this.wishlistService.wishlistScenes)).subscribe(
      data => {
        if (data['results']) {
          this.microService.sharedDataKey = data['results']['key'];
          // this.testSharedWishList(this.microService.sharedDataKey);
          this.shareWishList(this.microService.sharedDataKey);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  // testSharedWishList(key: string) {
  //   const url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port
  //     + '/' + this.apiService.builderPath + '/' + this.apiService.modelPath  + '/shared/' + key;
  //   window.open(url);
  // }

  shareWishList(key: string) {
    const title = this.tourService.tour.modelInfo.builder + ' - ' + this.tourService.tour.modelInfo.modelName + ' Wish List';
    const body = 'Click the link below to view the ' + this.tourService.tour.modelInfo.modelName + ' Wish List \n\n';
    const link = 'mailto:' + '?subject=' + title + '&body=' + encodeURI(body) + this.urlForSharedWishList(key);
    window.location.href = link;
  }

  urlForSharedWishList(key: string) {
    return window.location.protocol + '//' + window.location.hostname + ':' + window.location.port
    + '/' + this.apiService.builderPath + '/' + this.apiService.modelPath  + '/shared/' + key;
  }
}






// WEBPACK FOOTER //
// ./src/app/components/wishlist.component.ts